//*** Import React Library
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Modal from "react-bootstrap/Modal";
import * as FaIcons from "react-icons/fa";

import AxiosInstance from "../Axios/AxiosInstance";
import { hasJWTToken } from "../Account/RouteGuard";

import "../../Assets/Styles/robot.css";
import "../../Assets/Styles/Form.css";

// ====================== Edit Row Navigation ======================
const edit_row = (rowId) => {
    sessionStorage.setItem("editRowId", rowId);
    window.location.href = "#/EditRow?rid=" + rowId;
};

// ====================== Custom Styles for DataTable ======================
const customStyles = {
    table: { style: { border: "none", fontSize: "100%" } },
    headCells: { style: { fontWeight: 700, fontSize: "110%" } },
};

// ====================== Component ======================
export const SearchRow = () => {
    // --------- State ---------
    const [searchTerm, setSearchTerm] = useState("");
    const [rowData, setRowData] = useState([]);
    const [rowList, setRowList] = useState([]);
    const [rowID, setRowID] = useState("");
    const [rowName, setRowName] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const role_id = sessionStorage.getItem("role_id");

    // ====================== Table Columns ======================
    const columns = [
        {
            name: "ID",
            selector: (row) => (
                <a className="alink" onClick={() => edit_row(row.row_id)}>
                    {row.row_id}
                </a>
            ),
            sortable: true,
        },
        { name: "Plant Name", selector: (row) => row.plant_name, sortable: true },
        { name: "Row Name", selector: (row) => row.row_name, sortable: true },
        { name: "Date", selector: (row) => row.row_added_date, sortable: true },
        {
            name: "Delete",
            selector: (row) => (
                <a className="alink" onClick={() => handleShowDelete(row.row_id, row.row_name)}>
                    Delete
                </a>
            ),
        },
    ];

    // ====================== Show Delete Modal ======================
    const handleShowDelete = (id, name) => {
        setRowID(id);
        setRowName(name);
        setShowDeleteModal(true);
    };

    // ====================== Hide Delete Modal ======================
    const handleHideModal = () => setShowDeleteModal(false);

    // ====================== Fetch Row Data ======================
    const fetchRowData = async () => {
        try {
            const user_id = sessionStorage.getItem("user_id");
            const response = await AxiosInstance.get(
                `/PlantRow?rid=1&uid=${user_id}&pn=SearchRow&sn=SearchAllRow`
            );

            if (response.data) {
                setRowData(response.data);
                setRowList(response.data);
            }
        } catch (error) {
            console.log("Error fetching rows:", error);
        }
    };

    // ====================== Delete Row ======================
    const deleteRecord = async () => {
        try {
            const user_id = sessionStorage.getItem("user_id");
            await AxiosInstance.get(
                `/PlantRow/DeleteRow?rid=${rowID}&uid=${user_id}&pn=DeleteRow`
            );
            setShowDeleteModal(false);
            fetchRowData();
        } catch (error) {
            console.log("Error deleting row:", error);
        }
    };

    // ====================== Search Handler ======================
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (!value) return setRowList(rowData);

        const filtered = rowData.filter((item) =>
            Object.values(item).some(
                (val) => typeof val === "string" && val.toLowerCase().includes(value.toLowerCase())
            )
        );

        setRowList(filtered);
    };

    // ====================== Lifecycle ======================
    useEffect(() => {
        fetchRowData();
    }, []);

    // ====================== Render ======================
    return (
        <>
            {hasJWTToken() ? (
                <div className="page-container" style={{ backgroundColor: "white" }}>
                    <p>&nbsp;</p>

                    {/* -------- Page Title -------- */}
                    <h2 className="form-title">
                        <FaIcons.FaSearch /> Search Row
                    </h2>

                    {/* -------- Action Row: Add Row + Search Input -------- */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <a className="btndelete" href="#/PlantRow">
                            Add New Row
                        </a>

                        <input
                            type="text"
                            placeholder="Search Results"
                            value={searchTerm}
                            onChange={handleSearch}
                            style={{
                                width: "25%",
                                borderRadius: "5px",
                                padding: "8px",
                                border: "1px solid #ccc",
                            }}
                        />
                    </div>

                    {/* -------- Table Container -------- */}
                    <div
                        style={{
                            border: "1px solid #c0c0c0",
                            borderRadius: "5px",
                            margin: "2%",
                            backgroundColor: "#fff",
                        }}
                    >
                        <div className="container dvscroll">
                            <DataTable
                                columns={columns}
                                data={rowList}
                                pagination
                                highlightOnHover
                                customStyles={customStyles}
                            />
                        </div>
                    </div>

                    {/* -------- Delete Confirmation Modal -------- */}
                    <Modal show={showDeleteModal} centered onHide={handleHideModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Row</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            Are you sure you want to delete Row ID: <strong>{rowID}</strong>?
                        </Modal.Body>

                        <Modal.Footer>
                            {/* Delete Button */}
                            <button className="btndelete"     
                                onClick={deleteRecord}
                            >
                                Delete
                            </button>

                            {/* Cancel Button */}
                            <button
                                className="btndelete"
                                onClick={handleHideModal}
                            >
                                Cancel
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            ) : (
                (window.location.href = "#/Login")
            )}
        </>
    );
};

export default SearchRow;
